<template>
  <div
    v-show="visible"
    v-loading="loading"
    class="details-view"
    style="overflow: auto;"
    element-loading-text="Loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(170,170,170,0.5)"
  >
    <div class="main-content" style="width: 1150px;overflow: unset;">
      <div class="section operations">
        <div class="triggers">
          <div>
            <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
            <el-button type="primary" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
          </div>
        </div>
      </div>
      <div class="section my-form">
        <span class="title">{{ $t('Warehouse.JobNumberInformation') }}</span>
        <el-form :disabled="true" :inline="true" label-width="85px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
            <el-input v-model="job.jobNo" />
          </el-form-item>
          <el-form-item label="MAWB No.">
            <el-input v-model="job.mbl" />
          </el-form-item>
          <el-form-item label="HAWB No.">
            <el-input :value="hawb?hawb.hblNbr2:''" />
          </el-form-item>
        </el-form>
        <el-form :disabled="true" :inline="true" label-width="85px" label-position="left">
          <el-form-item label="ETD">
            <el-input :value="job.etd.substr(0,10)" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCompany')">
            <el-input :value="carrierName" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FlightAndTime')">
            <el-input v-model="job.voyageFlight" />
          </el-form-item>
        </el-form>
        <el-form :disabled="true" :inline="true" label-width="85px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_PortOfLoading')">
            <el-input :value="loadingPortName" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_DestinationPort')">
            <el-input :value="destinationPortName" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AuthorizedClient')">
            <el-input :value="customerName" />
          </el-form-item>
        </el-form>
      </div>
      <div class="section my-form">
        <span class="title">{{ $t('Warehouse.WarehouseInformation') }}</span>
        <el-form label-width="85px" label-position="left" style="display: flex;">
          <div class="form-column">
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_WarehouseNo') }}</span>
              <cargo-input
                v-model="warehouseIn.warehouseNo"
                :auto-uppercase="true"
                @blur="warehouseIn.warehouseNo=warehouseIn.warehouseNo.trim()"
              />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.Warehouse')" class="required">
              <cargo-input v-model="warehouseIn.warehouse" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.Warehouseman')">
              <cargo-user-select
                :method-params="{category:'role',shape:'warehouseOp'}"
                :default-value="warehouseIn.warehouseOp||''"
                placeholder=" "
                @change="p=>{warehouseIn.warehouseOp=p.value}"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_EstimatedWarehousingTime')"
              prop="estimatedWarehousingTime"
            >
              <el-date-picker
                v-model="warehouseIn.estimatedWarehousingTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item
              class="required"
              :label="$t('CargoMsg.Cargo_ActualWarehousingTime')"
              prop="warehouseInDate"
            >
              <el-date-picker
                v-model="warehouseIn.warehouseInDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_EstimatedDeliveryTime')"
              prop="estimatedDeliveryTime"
            >
              <el-date-picker
                v-model="warehouseIn.estimatedDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
            <el-form-item
              :label="$t('CargoMsg.Cargo_ActualDeliveryTime')"
              prop="warehouseOutDate"
              class="auto-width"
            >
              <el-date-picker
                v-model="warehouseIn.warehouseOutDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </div>
          <div class="form-column">
            <el-form-item :label="$t('Warehouse.ReceiptNo')">
              <cargo-input v-model="warehouseIn.receiptNo" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DeliveryCmp')">
              <cargo-input v-model="warehouseIn.deliveryCmp" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.LicensePlate')">
              <cargo-input v-model="warehouseIn.truckNo" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.Driver')">
              <cargo-input v-model="warehouseIn.driver" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DriverPhone')">
              <cargo-input v-model="warehouseIn.driverTel" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.WarehouseLocation')">
              <cargo-input v-model="warehouseIn.location" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DeliveryMode')">
              <el-select v-model="warehouseIn.outType" placeholder=" ">
                <el-option v-for="(item,index) in WAREHOUSE_TYPES" :key="index" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
          </div>
          <div class="form-column">
            <el-form-item :label="$t('Warehouse.PalletSum')">
              <el-input-number
                :value="warehouseIn.palletSum>0?warehouseIn.palletSum:undefined"
                :min="0"
                :max="10"
                :precision="0"
                controls-position="right"
                :class="warehouseIn.palletSum>0?'':'empty-if-zero'"
                @input="value=>{warehouseIn.palletSum=value}"
              />
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="warehouseIn.receiveDc">{{ $t('Warehouse.ReceiveDc') }}</el-checkbox>
            </el-form-item>
            <el-form-item>
              <el-checkbox
                v-model="warehouseIn.broken"
                @change="warehouseIn.brokenQuantity=warehouseIn.broken?warehouseIn.brokenQuantity:0"
              >{{ $t('Warehouse.IsNotComputationIsAffectedByDampness') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('Warehouse.ComputationIsAffectedByDampnessNum')">
              <el-input-number
                v-model="warehouseIn.brokenQuantity"
                :disabled="!warehouseIn.broken"
                :min="0"
                :max="99999"
                :precision="0"
                controls-position="right"
              />
            </el-form-item>
            <el-form-item>
              <el-checkbox
                v-model="warehouseIn.sealCargo"
                @change="warehouseIn.sealWeight=warehouseIn.sealCargo?warehouseIn.sealWeight:0"
              >{{ $t('Warehouse.IsTheGoodsClosed') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('Warehouse.SealingWeight')">
              <el-input-number
                :value="warehouseIn.sealWeight>0?warehouseIn.sealWeight:undefined"
                :disabled="!warehouseIn.sealCargo"
                :min="0"
                :max="999999999999"
                :precision="1"
                controls-position="right"
                :class="warehouseIn.sealWeight>0?'':'empty-if-zero'"
                @input="value=>{warehouseIn.sealWeight=value}"
              />
            </el-form-item>
          </div>
          <div class="form-column">
            <el-form-item :label="$t('Warehouse.DescriptionOfGoods')">
              <cargo-input v-model="warehouseIn.brokenDes" :auto-uppercase="true" type="textarea" :rows="4" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.HandlingOpinions')">
              <cargo-input v-model="warehouseIn.comments" :auto-uppercase="true" type="textarea" :rows="4" />
            </el-form-item>
            <el-form-item :label="$t('Warehouse.Remark')">
              <cargo-input v-model="warehouseIn.remarks" :auto-uppercase="true" type="textarea" :rows="4" />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="section">
        <span class="title">{{ $t('Warehouse.CargoDetails') }}</span>
        <warehouse-detail-grid ref="detailGrid" :context="{}" action="look" :job="job" :warehouse-in="warehouseIn" :open-imperial="openImperial" />
      </div>
      <div class="section">
        <span class="title">{{ $t('Warehouse.CargoPhotos') }}</span>
        <warehouse-pic-grid ref="picGrid" :model="warehouseIn" @uploadDone="uploadDoneHandler" />
      </div>
      <div class="section">
        <span class="title">{{ $t('CargoMsg.Cargo_OperationRequirement') }}</span>
        <warehouse-operation-req-data-grid :job="job" @callback="value=>{operationfinishedItems=value}" />
      </div>
    </div>
    <job-by-warehouse-dialog
      :visible.sync="jobByWarehouseDialog.visible"
      :jobs="jobByWarehouseDialog.jobs"
      @callback="jobByWarehouseDialog.callback"
    />
  </div>
</template>

<script>
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import warehouseDetailGrid from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/components/warehouseDetailGrid'
import warehousePicGrid from '@/views/cargo/v0/AirExport/components/routeCentral/warehousePicGrid'
import warehouseOperationReqDataGrid from '@/views/cargo/v0/AirExport/components/stayWarehousing/warehouseOperationReqDataGrid'
import jobByWarehouseDialog from '@/views/cargo/v0/AirExport/components/stayWarehousing/jobByWarehouseDialog'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { WAREHOUSE_TYPES } from '@/class/cargo/model/parameters/WarehouseInConsts'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { queryJobByWarehouseNoFunc } from '@/api/warehouseIn/warehouseIn'
import { saveWarehouseInForAe } from '@/api/seaExport/warehouseIn'
import { updateOperationRequirementState } from '@/api/AirExport/operationRequirement'

export default {
  name: 'StayWarehousingTabForm',
  components: { cargoInput, cargoUserSelect, warehouseDetailGrid, warehousePicGrid, warehouseOperationReqDataGrid, jobByWarehouseDialog },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    openImperial: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      loading: false,
      WAREHOUSE_TYPES,
      hawb: null,
      warehouseIn: new WarehouseIn().fillDefaultValue().getData(),
      operationfinishedItems: [],
      jobByWarehouseDialog: {
        visible: false,
        jobs: [],
        callback: () => { }
      }
    }
  },
  computed: {
    carrierName() {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.carrierId, 'chineseName')
    },
    loadingPortName() {
      return this.job.loadingPortCode + ' ' + ColumnUtils.portLabelFunc(this.job, this.job.loadingPortCode)
    },
    destinationPortName() {
      return this.job.destinationPortCode + ' ' + ColumnUtils.portLabelFunc(this.job, this.job.destinationPortCode)
    },
    customerName() {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId, 'chineseName')
    }
  },
  watch: {
    visible(newVal) {
      const jobModel = new AirExportJob(this.job)
      jobModel.getCargoDoc(CargoDocConsts.HAWB, false).then(data => {
        this.hawb = data
      })
      this.warehouseIn = new WarehouseIn().fillDefaultValue().getData()
      this.warehouseIn.lob = 'AE'
      this.warehouseIn.warehouseNo = this.job.warehouseNo
      this.warehouseIn.warehouseInDate = moment().format('YYYY-MM-DD HH:mm:ss')
      this.warehouseIn.branchId = this.$store.getters.currentOfficeId
      this.warehouseIn.warehouseOp = this.$store.getters.userId
      this.warehouseIn.job = this.job
      this.warehouseIn.jobUuid = this.job.uuid
      // 进仓时同步job上的预计入库时间和预计出库时间
      this.warehouseIn.estimatedWarehousingTime = this.job.estimatedDateOfWarehousinge
      this.warehouseIn.estimatedDeliveryTime = this.job.estimatedDeliveryTime
      this.$refs.detailGrid.fillView()
      this.$refs.picGrid.init()
    }
  },
  methods: {
    async save() {
      if (!this.validateForm()) {
        return
      }
      this.checkWarehouseJob(async() => {
        this.loading = true
        await this.$refs.picGrid.upload().finally(() => {
          this.loading = false
        })
        this.$refs.picGrid.onClose()
      })
    },
    validateForm() {
      if (!this.warehouseIn.warehouseNo.trim()) {
        this.$message.warning(this.$t('AirExport.PleaseTheWarehouseEntryNumber'))
        return false
      }
      if (!this.warehouseIn.warehouseInDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterActualWarehousingTime'))
        return false
      }
      if (this.warehouseIn.sealCargo && !(this.warehouseIn.sealWeight > 0)) {
        this.$message.warning(this.$t('AirExport.PleaseWeightOfTheSeal'))
        return false
      }
      if (!this.warehouseIn.warehouse.trim()) {
        this.$message.warning(this.$t('AirExport.PleaseEnterTheWarehouseName'))
        return false
      }
      return this.$refs.detailGrid.validate()
    },
    async checkWarehouseJob(callback) {
      if (this.warehouseIn.warehouseNo !== this.job.warehouseNo) {
        this.loading = true
        const res = await queryJobByWarehouseNoFunc({
          warehouseNo: this.warehouseIn.warehouseNo,
          branchId: this.$store.getters.currentOfficeId
        }).finally(() => {
          this.loading = false
        })
        if (res.data.length === 1) {
          this.warehouseIn.job = this.res.data[0]
          this.warehouseIn.jobUuid = this.res.data[0].uuid
          callback()
        } else if (res.data.length > 1) {
          this.jobByWarehouseDialog.jobs = res.data
          this.jobByWarehouseDialog.callback = obj => {
            this.warehouseIn.job = obj
            this.warehouseIn.jobUuid = obj.uuid
            callback()
          }
          this.jobByWarehouseDialog.visible = true
        }
      } else {
        this.warehouseIn.job = this.job
        this.warehouseIn.jobUuid = this.job.uuid
        callback()
      }
    },
    async uploadDoneHandler() {
      const ajaxResults = []
      this.warehouseIn.warehouseInDetail = this.$refs.detailGrid.rowData
      ajaxResults.push(saveWarehouseInForAe(this.warehouseIn))
      if (this.operationfinishedItems.length > 0) {
        const finished = this.operationfinishedItems[0].finished
        ajaxResults.push(
          updateOperationRequirementState({
            uuids: Array.from(this.operationfinishedItems, p => p.operationRequirementUUID).join(','),
            finished: finished ? 0 : 1,
            finishedDate: finished ? '' : moment().format('YYYY-MM-DD HH:mm:ss'),
            remarks: ''
          })
        )
      }
      this.loading = true
      try {
        const results = await Promise.all(ajaxResults)
        if (results[0].data && this.warehouseIn.business_Document) {
          for (const item of this.warehouseIn.business_Document) {
            item.warehouseInUuid = results[0].data.uuid
          }
        }
        await this.$refs.picGrid.submit()
        this.$emit('back', true)
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.$emit('back', false)
    }
  }
}
</script>

<style scoped lang="scss">
#app .details-view .main-content ::v-deep {
  .section.my-form {
    .el-form-item__content {
      width: 190px;
      .el-date-editor,
      .el-input-number {
        width: 100%;
      }
    }
    .form-column {
      width: unset;
      margin-left: 0px;
      margin-right: 10px;
    }
  }
  .el-input-number__increase.is-disabled,
  .el-input-number__decrease.is-disabled {
    pointer-events: none;
  }
  .empty-if-zero {
    .el-input-number__decrease {
      pointer-events: none;
      color: #cccccc;
    }
  }
}
</style>
